var map = {
	"./advancing-metabolic-healthcare-with-aws-cloud-ai-services.json": 541,
	"./ai-for-a-cause-a-nonprofit-modernization-journey.json": 679,
	"./ai-for-good-rising-routes.json": 972,
	"./amazon-quick-phoenix-user-group.json": 322,
	"./amazon-rds-for-sql-just-got-better.json": 522,
	"./coffee-talk-with-etrigue.json": 770,
	"./finance-first-cloud-management.json": 995,
	"./from-ai-ambition-to-measurable-impact.json": 626,
	"./linux-foundation.json": 748,
	"./nasdaq-center-milestone-circles.json": 449,
	"./no-is-not-a-policy.json": 629,
	"./nonprofit-youth-services-organization-transforms-communications-with-amazon-connect.json": 663,
	"./operationalizing-clinical-intelligence-with-aws-serverless-architecture.json": 185,
	"./the-channel-company-crn.json": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 957;